import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Box } from 'grommet';
import * as UserDucks from 'granite-admin/accounts/ducks/user';
import * as OrganisationDucks from 'granite-admin/organisations/ducks/organisations';
import { getGrandEmitter } from 'granite-admin/utils/grandEmitter';
import WorkspaceTabs from '../components/WorkspaceTabs';
const DashboardHeader = ({
  history,
  dispatch,
  userProfile,
  selectedOrganisation,
  breadcrumbPath,
  addTabBtn
}) => {
  const grandEmitter = useMemo(() => getGrandEmitter(), []);
  return /*#__PURE__*/React.createElement(Box, {
    flex: {
      grow: 1
    },
    align: "center",
    direction: "row",
    justify: userProfile.isSystemAdmin && selectedOrganisation?.pk ? 'between' : 'end',
    background: "light-2"
  }, /*#__PURE__*/React.createElement(WorkspaceTabs, {
    history: history,
    maxTabs: 8,
    businessAdmin: userProfile.isSystemAdmin,
    selectedOrganisation: selectedOrganisation,
    eventEmitter: grandEmitter,
    breadcrumbPath: breadcrumbPath,
    addTabBtn: addTabBtn
  }));
};
const mapStateToProps = state => ({
  userProfile: UserDucks.profile(state),
  selectedOrganisation: OrganisationDucks.selectedOrganisation(state)
});
const mapDispatchToProps = dispatch => ({
  dispatch: dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(DashboardHeader);